/* @flow */
import humanparser from 'humanparser';
import React from 'react';

import AuthActions from 'auth/AuthActions';
import Button from 'components/Button.jsx';
import Device from 'entities/Device';
import DividerText from 'components/DividerText.jsx';
import Form from 'components/Form.jsx';
import FormInput from 'components/FormInput.jsx';
import GoogleSignIn from 'auth/components/GoogleSignIn.jsx';
import TosText from 'components/TosText.jsx';
import UserActions from 'user/UserActions';

const JoinSignUpForm = React.createClass({
  propTypes: {
    onUserCreate: React.PropTypes.func.isRequired,
    defaultValues: React.PropTypes.object,
    role: React.PropTypes.string,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getDefaultProps() {
    return {
      defaultValues: {},
      role: '',
    };
  },

  getInitialState() {
    return {
      canSubmit: false,
    };
  },

  onSubmit(attrs: {email: string, password: string, full_name: string}, _: any, invalidateForm: Function) {
    const doLogin = () => {
      const onSignInSuccess = () => {
        this.props.onUserCreate();
      };

      const onSignInFailure = () => {
        invalidateForm({ email: 'Email has already been taken' });
      };

      AuthActions
        .signIn(attrs.email, attrs.password)
        .then(onSignInSuccess, onSignInFailure);
    };

    const doSignup = () => {
      const human = humanparser.parseName(attrs['full_name']);
      const role = this.props.role ? this.props.role : '';
      const userData = {
        email: attrs.email,
        prefix: human.salutation,
        password: attrs.password,
        last_name: human.lastName,
        first_name: human.firstName,
        role, /* !!DO NOT REMOVE THIS!!! otherwise it will default to teacher */
      };

      const onError = (error) => {
        const errors = {};

        if (error.code === 'email_used_by_google_sign_in') {
          invalidateForm({ email: error.error });
          return;
        }

        for (const field of error.field_errors) {
          errors[field['field_name']] = field.messages.join(', ');
        }

        invalidateForm(errors);
      };

      UserActions
        .create(userData)
        .then(this.props.onUserCreate, onError);
    };

    Device
      .belongsToFullAccount('email://' + attrs.email)
      .then(doLogin, doSignup);
  },

  render() {
    return (
      <div>
        <Form
          onSubmit={this.onSubmit}
          onValid={() => this.setState({ canSubmit: true })}
          onInvalid={() => this.setState({ canSubmit: false })}>
          <FormInput
            label="Full name"
            type="text"
            size="large"
            name="full_name"
            autoComplete="name"
            placeholder="First and last name"
            validations="minLength:3"
            // $FlowIssue
            value={this.props.defaultValues['full_name']}
            showErrorAfterBlur
            className="JoinSignUpForm-Name"
            validationErrors={{
              minLength: 'Names should be at least 3 characters long.',
            }}
          />
          <FormInput
            label="Email"
            type="email"
            name="email"
              // even though this is an email, let the browser know to use this as username in the future
            autoComplete="username"
            size="large"
            // $FlowIssue
            value={this.props.defaultValues['email']}
            placeholder={'name@example.com'}
            showErrorAfterBlur
            validations="minLength:1"
            className="JoinSignUpForm-Email"
            validationErrors={{
              minLength: 'Invalid, must not be empty',
            }}
          />
          <FormInput
            label="Password"
            type="password"
            name="password"
            autoComplete="new-password"
            size="large"
            placeholder="New password"
            showErrorAfterBlur
            validations="minLength:6"
            className="JoinSignUpForm-Password"
            validationErrors={{
              minLength: 'Passwords should be at least 6 characters long.',
            }}
          />
          <Button
            type="submit"
            level="primary"
            full
            className="JoinSignUpForm-Submit"
            disabled={!this.state.canSubmit}
            eventElementName="JoinSignUpForm-Submit">
            Sign up
          </Button>
        </Form>

        <DividerText text="or" uppercase />

        <GoogleSignIn body="Sign up with Google" onSuccess={this.props.onUserCreate} />

        <TosText className="JoinSignUpForm-tos" />
      </div>
    );
  },
});

export default JoinSignUpForm;



// WEBPACK FOOTER //
// ./src/join/components/JoinSignUpForm.jsx